function toBeImplemented() {
  // eslint-disable-next-line no-alert
  alert('To be implemented');
}

export default toBeImplemented;
